;(function (global, factory) {
    typeof define === 'function' && define.amd ? define('SageDotCom/Utility/gatedContentHelper',['jquery'], factory) :
    typeof exports === 'object' && typeof module !== typeof void 0 ? module.exports = factory(require('jquery')) :
    console && console.error('GatedContentHelper loaded in a wrong way');
}(this/* window */, function ($) {

    function GatedContentHelper() {}

    // documentation provides approach to load gatedContent on an entire page, instead of just an element, so we ignore scope for now
    // https://cirrus1.freshdesk.com/support/solutions/articles/36000090392-issues-working-with-angular-or-react-apps

    GatedContentHelper.prototype.loadGatedContent = function(scope) {
        
        if(!'gcdc' in window) {
            console && console.debug && console.debug('gcdc is not loaded. retry to load gated content in 50ms');
            setTimeout(this.loadGatedContent.bind(this, scope), 50);
            return;
        }

        window.removeEventListener('gcdcModalOpened', this._closeUiPopup);
        window.gcdc('loadGates');
        window.addEventListener('gcdcModalOpened', this._closeUiPopup);
    }

    GatedContentHelper.prototype.unLoadGatedContent = function(scope) {
        if(!'gcdc' in window) {
            console && console.debug && console.debug('gcdc is not loaded. retry to load gated content in 50ms');
            setTimeout(this.loadGatedContent.bind(this, scope), 50);
            return;
        }

        const container = scope || document;

        container.querySelectorAll('*[href^="#gate-"]').forEach(el => { 
            el.removeAttribute('gcdc-modal-linked');
        });

        window.removeEventListener('gcdcModalOpened', this._closeUiPopup);
        window.gcdc('loadGates');
        window.addEventListener('gcdcModalOpened', this._closeUiPopup);
    }

    GatedContentHelper.prototype._closeUiPopup = function() {
        // there is an issue, GatedContent forms cannot be filled out if a Bootstrap Modal is opened on a page.
        $('.modal:visible').modal('hide');
    }

    return new GatedContentHelper(); // singleton
}));
